module.exports = __webpack_public_path__ + "static/img/followUpQrCode.67c5903.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/footer/followUpQrCode.png
// module id = +2yB
// module chunks = 32